export default "__VITE_ASSET__BCMYdJbo__"